import { render, staticRenderFns } from "./AccountAssetFormProperty.vue?vue&type=template&id=5f6623d0&scoped=true&"
import script from "./AccountAssetFormProperty.vue?vue&type=script&lang=ts&"
export * from "./AccountAssetFormProperty.vue?vue&type=script&lang=ts&"
import style0 from "./AccountAssetFormProperty.vue?vue&type=style&index=0&id=5f6623d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6623d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
